import React from 'react';
import { IconProps } from '@/models/IconProps';

const BottomBarWindowIcon: React.FC<IconProps> = ({ height = '20', width = '20', strokeColor = '#1F2126' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={'0 0 ' + width + ' ' + height}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width={width} height={height} fill="none" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 3C0.447715 3 0 3.44772 0 4V17C0 17.5523 0.447715 18 1 18H19C19.5523 18 20 17.5523 20 17V4C20 3.44772 19.5523 3 19 3H1ZM18.3333 4.66667H1.66667V16.3333H18.3333V4.66667Z"
        fill="#1F2126"
      />
      <rect x="2.5" y="10.5" width="15" height="5" rx="0.5" fill={strokeColor} />
    </svg>
  );
};

export default BottomBarWindowIcon;
